import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiUrlProvider } from './api-url.provider';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { Employee } from '../shared/models/employee';
import { Invoice } from '../shared/models/invoice';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  constructor(
    private http: HttpClient,
    private apiUrlProvider: ApiUrlProvider) { }

  getInvoices(): Observable<IApiResult<Invoice[]>>{
    return this.http.get<IApiResult<Invoice[]>>(`${this.apiUrlProvider.url}/invoice`);
  }

  createInvoice(projectId: number, formData: FormData): Observable<IApiResult<Invoice>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<Invoice>>(`${this.apiUrlProvider.url}/invoice?projectId=${projectId}`, formData);
  }

  updateInvoice(invoice: Invoice): Observable<IApiResult<Invoice>>{
    return this.http.post<IApiResult<Invoice>>(`${this.apiUrlProvider.url}/invoice/${invoice.id}`, invoice);
  }
}
